module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ko_kyushu-5b33d22d8606e15aa6c49ad6861820e1.jpg";